import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { TrustMetrics } from '../components/TrustMetrics';
import { Footer } from '../components/Footer';
import { Building2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-126">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-slate-200" data-id="element-127">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
          <div className="flex h-16 items-center justify-between" data-id="element-129">
            <div className="flex items-center gap-2" data-id="element-130">
              <Building2 className="h-6 w-6 text-blue-900" data-id="element-131" />
              <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-132">
                POWERQUEST
              </span>
            </div>
            <div className="hidden md:flex items-center gap-8" data-id="element-133">
              <a href="#" className="text-sm font-medium text-slate-600 hover:text-blue-900 transition-colors" data-id="element-134">
                Services
              </a>
              <a href="#" className="text-sm font-medium text-slate-600 hover:text-blue-900 transition-colors" data-id="element-135">
                Methodology
              </a>
              <a href="#" className="text-sm font-medium text-slate-600 hover:text-blue-900 transition-colors" data-id="element-136">
                Performance
              </a>
              <Button size="sm" data-id="element-137">Client Access</Button>
            </div>
          </div>
        </div>
      </nav>

      <main data-id="element-138">
        <Hero data-id="element-139" />
        <Services data-id="element-140" />
        <Process data-id="element-141" />
        <TrustMetrics data-id="element-142" />
      </main>

      <Footer data-id="element-143" />
    </div>;
}